'use client'

import { ArrowLeft, RotateCcw } from 'lucide-react'
import Link from 'next/link'
import React, { useEffect } from 'react'

import { reportTelemetryError } from '@/utilities/telemetry'

// Segment error boundary. Errors caught here never reach window.onerror, so we
// report them to RUM manually — they show up under RUM → Errors with the stack
// trace (symbolicated once source maps are uploaded for the matching version).
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    reportTelemetryError(error, { digest: error.digest, boundary: 'frontend' })
  }, [error])

  return (
    <section className="relative z-10 flex min-h-[70dvh] items-center justify-center px-4 py-32">
      <div className="container mx-auto max-w-xl">
        <div className="bg-white/60 backdrop-blur-xl border border-white/50 rounded-[2.5rem] shadow-2xl shadow-slate-200 p-10 md:p-14 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Coś poszło nie tak</h1>
          <p className="mt-3 text-slate-600 leading-relaxed">
            Wystąpił nieoczekiwany błąd. Spróbuj ponownie lub wróć na stronę główną.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={reset}
              className="group bg-red-600 text-white px-7 py-3.5 rounded-xl font-bold hover:bg-red-700 transition-all shadow-lg shadow-red-600/20 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-red-500/40 flex items-center justify-center gap-2"
            >
              <RotateCcw size={18} className="group-hover:-rotate-45 transition-transform" />
              Spróbuj ponownie
            </button>
            <Link
              href="/"
              className="bg-white text-slate-800 border border-slate-200 px-7 py-3.5 rounded-xl font-bold hover:bg-slate-50 transition-all active:scale-[0.98] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-slate-400/30 flex items-center justify-center gap-2"
            >
              <ArrowLeft size={18} />
              Strona główna
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
